import L from "leaflet";
import style from "../components/MainContent/Body/MyMap/Map.module.css"

export const mapIcons: Object | any = {
  LoaderCrane: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg height="30" viewBox="0 0 512 512" width="40">
        <path d="m461 282h18v26h-18z" />
        <path d="m125 212.636v10.552a4.835 4.835 0 0 0 4.8 5 6.726 6.726 0 0 1 6.77 6.737 6.649 6.649 0 0 1 -6.669 6.737 6.822 6.822 0 0 1 -6.851-6.758 5.01 5.01 0 0 0 -10.019 0 16.82 16.82 0 0 0 33.639.021c0-7.5-5.672-13.868-11.672-15.987v-6.063l7.573-7.438a14.868 14.868 0 0 0 4.429-10.847v-12.229a5.3 5.3 0 0 0 -4.969-5.361h-8.031v-55.578l60 33.058v-21.321l-69.935-20.984-1.439 2.98 1.374 3.326v58.519h-6.572a5.7 5.7 0 0 0 -5.428 5.361v12.229a15.493 15.493 0 0 0 5.052 10.847z" />
        <path d="m112.75 315.669a42.078 42.078 0 1 0 42.078 42.078 42.126 42.126 0 0 0 -42.078-42.078zm0 66.812a24.734 24.734 0 1 1 24.734-24.734 24.762 24.762 0 0 1 -24.734 24.734z" />
        <circle cx="112.75" cy="357.747" r="14.734" />
        <path d="m33 351h28.087a52.064 52.064 0 0 1 103.326 0h167.587v-66h-299zm276.58-55h5.613a5 5 0 0 1 0 10h-5.613a5 5 0 1 1 0-10zm-63 0h40.613a5 5 0 0 1 0 10h-40.613a5 5 0 0 1 0-10zm-90.616 1h68.493a5 5 0 0 1 0 10h-68.493a5 5 0 0 1 0-10z" />
        <path d="m174 245.019v29.981h75v-29.981a4.711 4.711 0 0 0 -4.619-5.019h-65.262a5.125 5.125 0 0 0 -5.119 5.019z" />
        <path d="m386.929 236h87.642l-33.593-47.258a32.788 32.788 0 0 0 -26.766-13.742h-42.212v46.669c0 8.271 6.657 14.331 14.929 14.331z" />
        <path d="m220 123a8 8 0 0 0 -16 0v107h16z" />
        <path d="m362 221.669v-46.669h-20v176h7.087a52.064 52.064 0 0 1 103.353 0h26.56v-33h-23.207c-2.762 0-4.793-1.623-4.793-4.384v-35.954c0-2.761 2.031-5.662 4.793-5.662h23.207v-26h-92.071c-13.785 0-24.929-10.546-24.929-24.331z" />
        <circle cx="400.75" cy="357.747" r="14.734" />
        <path d="m400.75 315.669a42.078 42.078 0 1 0 42.078 42.078 42.126 42.126 0 0 0 -42.078-42.078zm0 66.812a24.734 24.734 0 1 1 24.733-24.734 24.762 24.762 0 0 1 -24.733 24.734z" />
      </svg>`,
  }),
  Bus: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg width="40" height="30" viewBox="-100 -100 700 700">
        <g>
          <path
            d="M494.03,228.989l-68.72-23.735l-39.809-67.593c-13.327-21.001-22.402-27.855-62.358-27.855H27.866
		C12.479,109.807,0,122.286,0,137.662v148.169v26.527v14.6c0,15.381,12.479,27.865,27.866,27.865h14.788
		c1.836-30.591,27.152-54.854,58.201-54.854c31.048,0,56.363,24.263,58.202,54.854h200.24c1.106-18.06,10.519-35.368,26.973-45.781
		c27.237-17.258,63.3-9.176,80.557,18.058c5.473,8.646,8.383,18.179,8.952,27.724h18.255c15.387,0,27.853-12.484,27.853-27.865
		v-70.103C521.886,241.463,510.474,234.41,494.03,228.989z M389.464,212.847H262.479c-1.908,0-3.438-1.529-3.438-3.423v-67.431
		c0-1.894,1.529-3.423,3.438-3.423h90.94c1.882,0,4.687,0.7,6.074,3.423l33.39,67.426
		C392.883,211.317,391.357,212.847,389.464,212.847z M516.983,298.952c0,5.145-4.169,9.315-9.313,9.315h-28.717
		c-5.144,0-9.313-4.171-9.313-9.315v-20.958c0-5.144,4.17-9.312,9.313-9.312h28.717c5.145,0,9.313,4.169,9.313,9.312V298.952z
		 M100.155,306.174c-29.2,0-52.957,23.762-52.957,52.958c0,29.2,23.756,52.947,52.957,52.947c29.198,0,52.946-23.747,52.946-52.947
		C153.101,329.936,129.354,306.174,100.155,306.174z M100.155,395.276c-19.944,0-36.146-16.215-36.146-36.138
		c0-19.924,16.211-36.141,36.146-36.141c19.931,0,36.137,16.217,36.137,36.141C136.292,379.061,120.086,395.276,100.155,395.276z
		 M417.745,306.174c-29.2,0-52.96,23.762-52.96,52.958c0,29.2,23.76,52.947,52.96,52.947c29.197,0,52.953-23.747,52.953-52.947
		C470.698,329.936,446.942,306.174,417.745,306.174z M417.745,395.276c-19.937,0-36.147-16.215-36.147-36.138
		c0-19.924,16.217-36.141,36.147-36.141c19.938,0,36.141,16.217,36.141,36.141C453.885,379.061,437.678,395.276,417.745,395.276z"
          />
        </g>
      </svg>`,
  }),
  Tilt: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg width="40" height="30" viewBox="0 0 525.664 525.663">
        <g>
          <path
            d="M53.074,320.717c-18.015,0-32.679,14.662-32.679,32.679c0,18.022,14.665,32.688,32.679,32.688
		c18.032,0,32.689-14.665,32.689-32.688C85.763,335.379,71.106,320.717,53.074,320.717z M53.074,376.08
		c-12.506,0-22.688-10.167-22.688-22.685c0-12.512,10.175-22.688,22.688-22.688c12.516,0,22.7,10.176,22.7,22.688
		C75.773,365.913,65.59,376.08,53.074,376.08z M525.664,267.11v-20.484l-20.445-89.995c0-6.235-9.05-6.235-12.496-6.235H384.716
		c-3.442,0-6.243,0.654-6.243,6.235v163.898c0,16.328,2.801,19.13,6.243,19.13h22.033c6.911-15.213,22.244-25.817,40.019-25.817
		c17.763,0,33.077,10.61,40.001,25.817h32.644c3.449,0,6.251-2.802,6.251-6.248v-31.51h-5.873V267.11H525.664z M426.593,246.503
		h-23.617v-4.796h23.617V246.503z M398.243,234.046V167.05h90.193l10.31,66.996H398.243z M503.041,325.092h-16.742
		c-4.729-9.018-15.039-15.464-15.039-15.464h31.781V325.092z M21.847,303.642h341.646v39.136H182.431
		c-6.14-16.869-22.333-28.936-41.288-28.936c-18.959,0-35.14,12.066-41.282,28.936h-4.046c-6.14-16.869-22.318-28.936-41.277-28.936
		c-18.677,0-34.658,11.721-41,28.186C5.722,339.779,0,332.584,0,324.036v-1.663c0-4.235,1.457-8.082,3.814-11.219v-15.282
		L3.637,139.58h354.409l-0.357,156.302H21.847V303.642z M445.302,320.717c-18.021,0-32.687,14.662-32.687,32.679
		c0,18.022,14.665,32.688,32.687,32.688c18.022,0,32.685-14.665,32.685-32.688C477.987,335.379,463.325,320.717,445.302,320.717z
		 M445.302,376.08c-12.512,0-22.688-10.167-22.688-22.685c0-12.512,10.165-22.688,22.688-22.688
		c12.518,0,22.697,10.176,22.697,22.688C468,365.913,457.811,376.08,445.302,376.08z M139.679,320.717
		c-18.02,0-32.686,14.662-32.686,32.679c0,18.022,14.666,32.688,32.686,32.688c18.026,0,32.684-14.665,32.684-32.688
		C172.363,335.379,157.706,320.717,139.679,320.717z M139.679,376.08c-12.506,0-22.693-10.167-22.693-22.685
		c0-12.512,10.181-22.688,22.693-22.688c12.511,0,22.694,10.176,22.694,22.688C162.374,365.913,152.19,376.08,139.679,376.08z"
          />
        </g>
      </svg>`,
  }),
  Tanker: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg height="30" width="40" viewBox="0 0 511.999 511.999">
        <g>
          <g>
            <path
              d="M103.774,356.715h-0.081c-4.142,0-7.46,3.358-7.46,7.5c0,4.142,3.398,7.5,7.541,7.5s7.5-3.358,7.5-7.5
			C111.274,360.072,107.916,356.715,103.774,356.715z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M167.903,356.715h-0.08c-4.142,0-7.46,3.358-7.46,7.5c0,4.142,3.398,7.5,7.54,7.5c4.142,0,7.5-3.358,7.5-7.5
			C175.403,360.072,172.045,356.715,167.903,356.715z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M424.419,356.715h-0.08c-4.142,0-7.46,3.358-7.46,7.5c0,4.142,3.398,7.5,7.54,7.5c4.142,0,7.5-3.358,7.5-7.5
			C431.919,360.072,428.561,356.715,424.419,356.715z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M505.107,266.038l-10.084-10.085l-20.315-60.946c3.031-0.963,5.228-3.798,5.228-7.147c0-4.142-3.358-7.5-7.5-7.5h-72.145
			c-8.556,0-15.516,6.96-15.516,15.516v80.678h-37.869c12.969-15.287,20.804-35.059,20.804-56.629
			c0-48.336-39.325-87.661-87.661-87.661h-64.645v-8.528c0-8.556-6.96-15.516-15.516-15.516h-32.064
			c-8.556,0-15.516,6.96-15.516,15.516v8.528H87.661C39.325,132.262,0,171.587,0,219.923c0,45.81,35.323,83.52,80.161,87.337v17.389
			H23.532c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h8.532v16.549c0,8.556,6.96,15.516,15.516,15.516h17.271
			c3.516,18.24,19.591,32.064,38.842,32.064c13.182,0,24.871-6.486,32.065-16.428c7.194,9.942,18.883,16.428,32.064,16.428
			c19.251,0,35.327-13.824,38.842-32.064h178.832c3.516,18.24,19.591,32.064,38.842,32.064c21.816,0,39.564-17.749,39.564-39.564
			c0-0.172-0.011-0.341-0.013-0.512h32.594c8.556,0,15.516-6.96,15.516-15.516v-65.508C512,276.392,509.552,270.481,505.107,266.038
			z M64.85,356.715H47.581c-0.285,0-0.517-0.232-0.517-0.516V339.65h25.648C68.829,344.538,66.076,350.355,64.85,356.715z
			 M384.774,291.552v33.097h-97.226V307.26c15.908-1.354,30.618-6.972,42.978-15.708H384.774z M167.306,123.735L167.306,123.735
			c0.001-0.285,0.232-0.516,0.517-0.516h32.064c0.285,0,0.516,0.231,0.516,0.516v8.528h-33.097V123.735z M15,219.923
			c0-37.533,28.606-68.509,65.161-72.275v16.164c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-16.55h177.387v16.55
			c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-16.164c36.555,3.766,65.161,34.742,65.161,72.275
			c0,37.534-28.606,68.51-65.161,72.275V195.87c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v96.714H95.161V195.87
			c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v96.328C43.606,288.434,15,257.457,15,219.923z M103.693,388.778
			c-13.545,0-24.564-11.02-24.564-24.564s11.02-24.564,24.564-24.564s24.565,11.02,24.565,24.564S117.238,388.778,103.693,388.778z
			 M167.823,388.778c-13.545,0-24.564-11.02-24.564-24.564s11.02-24.564,24.564-24.564s24.564,11.02,24.564,24.564
			S181.368,388.778,167.823,388.778z M95.161,324.65v-17.064h177.387v17.064H95.161z M385.497,356.715H206.665
			c-1.226-6.359-3.979-12.178-7.862-17.064h194.555C389.475,344.536,386.722,350.354,385.497,356.715z M480.734,260.52h-48.379
			c-0.285,0-0.516-0.231-0.516-0.516v-32.581h37.863L480.734,260.52z M424.339,388.778c-13.545,0-24.564-11.02-24.564-24.564
			s11.02-24.564,24.564-24.564s24.564,11.02,24.564,24.564S437.884,388.778,424.339,388.778z M497.001,300.606h-8.532
			c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5H497v32.581c0,0.283-0.231,0.515-0.516,0.515h-35.752
			c-6.045-14.127-20.08-24.052-36.393-24.052h-24.564V195.876c0-0.285,0.231-0.516,0.516-0.516h58.723l5.688,17.064h-40.363
			c-4.142,0-7.5,3.358-7.5,7.5v40.081c0,8.556,6.96,15.516,15.516,15.516h61.022l1.125,1.125c1.611,1.611,2.499,3.753,2.499,6.033
			V300.606z"
            />
          </g>
        </g>
      </svg>`,
  }),
  Container: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg width="40" height="30" viewBox="0 0 525.672 525.673">
        <g>
          <path
            d="M53.088,320.723c-18.015,0-32.68,14.665-32.68,32.679c0,18.024,14.665,32.689,32.68,32.689
		c18.035,0,32.688-14.665,32.688-32.689C85.776,335.388,71.118,320.723,53.088,320.723z M53.088,376.09
		c-12.506,0-22.688-10.164-22.688-22.688c0-12.504,10.175-22.691,22.688-22.691c12.516,0,22.697,10.176,22.697,22.691
		C75.78,365.915,65.604,376.09,53.088,376.09z M525.664,267.123v-20.489l-20.438-89.995c0-6.236-9.048-6.236-12.495-6.236H384.73
		c-3.446,0-6.248,0.654-6.248,6.236v163.897c0,16.328,2.802,19.13,6.248,19.13h22.038c6.911-15.212,22.249-25.812,40.01-25.812
		c17.762,0,33.086,10.604,40,25.812h32.657c3.446,0,6.237-2.802,6.237-6.243v-31.508h-5.864v-34.792H525.664z M426.608,246.511
		h-23.621v-4.797h23.621V246.511z M398.257,234.054v-66.997h90.189l10.317,66.997H398.257z M503.041,325.094h-16.738
		c-4.733-9.012-15.03-15.464-15.03-15.464h31.769V325.094z M21.858,295.884H357.7l0.355-156.302H3.647l0.175,156.302v15.286
		C1.458,314.303,0,318.15,0,322.386v1.663c0,8.548,5.722,15.743,13.538,17.992c6.347-16.466,22.323-28.187,41.004-28.187
		c18.957,0,35.138,12.065,41.28,28.936h4.041c6.14-16.87,22.323-28.936,41.279-28.936c18.957,0,35.148,12.065,41.292,28.936h181.059
		v-39.136H21.858V295.884z M307.121,150.403h25.781v133.915h-25.781V150.403z M267.531,150.403h25.778v133.915h-25.778V150.403z
		 M227.443,150.403h25.776v133.915h-25.776V150.403z M187.846,150.403h25.776v133.915h-25.776V150.403z M149.896,150.403h25.776
		v133.915h-25.776V150.403z M110.302,150.403h25.776v133.915h-25.776V150.403z M70.198,150.403h25.776v133.915H70.198V150.403z
		 M30.604,150.403H56.38v133.915H30.604V150.403z M445.322,320.723c-18.028,0-32.689,14.665-32.689,32.679
		c0,18.024,14.661,32.689,32.689,32.689c18.014,0,32.679-14.665,32.679-32.689C478,335.388,463.325,320.723,445.322,320.723z
		 M445.322,376.09c-12.518,0-22.692-10.164-22.692-22.688c0-12.504,10.169-22.691,22.692-22.691
		c12.504,0,22.688,10.176,22.688,22.691C468,365.915,457.826,376.09,445.322,376.09z M139.698,320.723
		c-18.027,0-32.69,14.665-32.69,32.679c0,18.024,14.663,32.689,32.69,32.689c18.025,0,32.678-14.665,32.678-32.689
		C172.376,335.388,157.717,320.723,139.698,320.723z M139.698,376.09c-12.506,0-22.701-10.164-22.701-22.688
		c0-12.504,10.188-22.691,22.701-22.691c12.511,0,22.686,10.176,22.686,22.691C162.379,365.915,152.205,376.09,139.698,376.09z"
          />
        </g>
      </svg>`,
  }),
  Cargo: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg viewBox="-250 -200 1000 1000" width="40" height="30">
        <g>
          <path d="m497 362h-16c0-8.535 0-338.954 0-347 0-8.284-6.716-15-15-15-11.847 0-408.153 0-420 0-8.284 0-15 6.716-15 15v180 167h-16c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h121v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h121v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15 0-14.518 0-105.386 0-120 0-8.284-6.716-15-15-15zm-226 0v-152h45v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45v152zm75-152h30v30h-30zm105-30h-180v-150h45v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45zm-105-150h30v30h-30zm-210 0h30v30h-30zm-30 0v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45v150h-180v-150zm30 180h30v30h-30zm-75 0h45v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45v152h-180zm-31 182h452v30h-452zm30 90h-30v-30h30zm211 0h-30v-30h30zm181 0v-30h30v30z" />
        </g>
      </svg>`,
  }),
  Crane: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg height="30" viewBox="0 0 64 64" width="40">
        <g>
          <g>
            <path d="m63.002 48.006c-.553 0-1-.447-1-1v-12.995c0-.553.447-1 1-1s1 .447 1 1v12.995c0 .553-.447 1-1 1z" />
          </g>
          <g>
            <path d="m63.003 35.011c-.367 0-.721-.202-.896-.553l-5-10.002c-.247-.494-.047-1.095.447-1.342.493-.248 1.096-.047 1.342.447l5 10.002c.247.494.047 1.095-.447 1.342-.143.072-.296.106-.446.106z" />
          </g>
          <g>
            <path d="m63.002 45.004h-10.996c-.553 0-1-.447-1-1s.447-1 1-1h10.996c.553 0 1 .447 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m63.002 48.006h-5.797c-.553 0-1-.447-1-1s.447-1 1-1h5.797c.553 0 1 .447 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m43.005 42.001h-38.008c-.553 0-1-.447-1-1s.447-1 1-1h38.008c.553 0 1 .447 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m58.002 25.009h-14.999c-.553 0-1-.448-1-1s.447-1 1-1h14.999c.553 0 1 .448 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m43.005 50.002c-.552 0-1-.447-1-1l-.002-24.993c0-.552.447-1 1-1 .552 0 1 .448 1 1l.002 24.993c0 .552-.447 1-1 1z" />
          </g>
          <g>
            <path d="m58.023 35.011c-.005.001-.012.001-.02 0h-10.998c-.553 0-1-.447-1-1v-6c0-.552.447-1 1-1h7.997c.379 0 .725.214.895.553l2.921 5.839c.13.169.206.38.206.608-.001.552-.448 1-1.001 1zm-10.018-2h8.381l-2.002-4h-6.379z" />
          </g>
          <g>
            <path d="m52.006 57.002c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zm0-12c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
          </g>
          <g>
            <path d="m27.007 57.002c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zm0-12c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
          </g>
          <g>
            <path d="m13.013 57.002c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zm0-12c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
          </g>
          <g>
            <path d="m13.013 53.002c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.449-1-1-1z" />
          </g>
          <g>
            <path d="m27.007 53.002c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z" />
          </g>
          <g>
            <path d="m52.004 53.002c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z" />
          </g>
          <g>
            <path d="m21.091 50.002h-2.154c-.553 0-1-.447-1-1s.447-1 1-1h2.154c.553 0 1 .447 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m46.089 50.002h-13.166c-.553 0-1-.447-1-1s.447-1 1-1h13.166c.553 0 1 .447 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m7.097 50.002h-5.103c-.553 0-1-.447-1-1s.447-1 1-1h5.103c.553 0 1 .447 1 1s-.448 1-1 1z" />
          </g>
          <g>
            <path d="m1.994 50.002c-.117 0-.235-.021-.352-.063-.517-.194-.778-.771-.585-1.288l3.003-8.001c.195-.518.771-.777 1.288-.585.517.194.778.771.585 1.288l-3.003 8.001c-.151.401-.532.648-.936.648z" />
          </g>
          <g>
            <path d="m47.999 38.009h-1c-.553 0-1-.447-1-1s.447-1 1-1h1c.553 0 1 .447 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <g>
              <path d="m35.992 42.034h-17.008c-.553 0-1-.447-1-1v-5.031c0-.553.447-1 1-1h17.008c.553 0 1 .447 1 1v5.031c0 .553-.447 1-1 1zm-16.008-2h15.008v-3.031h-15.008z" />
            </g>
            <g>
              <path d="m22.987 37.003c-.553 0-1-.447-1-1v-6.001c0-.552.447-1 1-1s1 .448 1 1v6.001c0 .553-.447 1-1 1z" />
            </g>
            <g>
              <path d="m31.989 37.003c-.553 0-1-.447-1-1v-7.001c0-.552.447-1 1-1s1 .448 1 1v7.001c0 .553-.447 1-1 1z" />
            </g>
            <g>
              <path d="m22.987 31.002c-.238 0-.478-.085-.669-.257l-19.993-18.002c-.41-.37-.443-1.002-.074-1.412s1.002-.442 1.412-.074l19.993 18.002c.41.37.443 1.002.074 1.412-.197.219-.469.331-.743.331z" />
            </g>
            <g>
              <path d="m31.988 30.002c-.203 0-.408-.062-.586-.19l-28.995-21.004c-.447-.324-.547-.949-.222-1.396.322-.447.947-.549 1.396-.224l28.995 21.004c.447.324.547.949.223 1.396-.195.27-.501.414-.811.414z" />
            </g>
            <g>
              <path d="m2.998 32.004c-.552 0-1-.448-1-1l-.004-23.006c0-.552.447-1 1-1 .552 0 1 .448 1 1l.004 23.006c0 .552-.447 1-1 1z" />
            </g>
          </g>
          <g>
            <path d="m2.998 37.006c-1.654 0-3-1.347-3-3.001 0-.553.447-1 1-1s1 .447 1 1c0 .552.448 1.001 1 1.001s1-.449 1-1.001c0-1.343-1.438-2.102-1.453-2.109-.488-.253-.685-.854-.436-1.343.25-.49.845-.689 1.336-.442.104.052 2.553 1.307 2.553 3.895 0 1.653-1.346 3-3 3z" />
          </g>
          <g>
            <path d="m3.998 30.005h-2c-.553 0-1-.448-1-1s.447-1 1-1h2c.553 0 1 .448 1 1s-.447 1-1 1z" />
          </g>
          <g>
            <path d="m19.985 37.003c-.389 0-.759-.229-.92-.609l-5.987-14.094c-.217-.508.021-1.096.529-1.312.504-.214 1.096.021 1.311.529l5.987 14.095c.217.508-.021 1.095-.529 1.311-.127.055-.26.08-.391.08z" />
          </g>
          <g>
            <path d="m38.997 42.034c-.553 0-1-.447-1-1v-13.024c0-.552.447-1 1-1s1 .448 1 1v13.024c0 .553-.447 1-1 1z" />
          </g>
          <g>
            <path d="m42.995 29.01h-3.998c-.553 0-1-.448-1-1s.447-1 1-1h3.998c.553 0 1 .448 1 1s-.447 1-1 1z" />
          </g>
        </g>
      </svg>`,
  }),
  Mixer: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg height="30" viewBox="0 0 512 512" width="40">
        <g>
          <path d="m504.5 294.98c4.143 0 7.5-3.358 7.5-7.5v-27.38c0-1.445-.261-2.878-.745-4.226l-.007-.024c-.013-.036-.03-.07-.043-.106-.447-1.203-1.047-2.286-1.781-3.246l-59.837-78.139c-2.341-3.086-6.059-4.928-9.947-4.928h-61.309c-6.897 0-12.51 5.607-12.51 12.5v89.719h-13.718v-12.025c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v12.025h-15.513v-61.178h15.514v14.152c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-17.485c0-6.433-5.233-11.666-11.667-11.666h-22.181c-6.433 0-11.666 5.233-11.666 11.666v11.607l-12.875-3.45 6.411-23.926c5.979-22.329-6.423-45.806-28.233-53.448l-26.61-9.33c-3.911-1.372-8.189.687-9.559 4.596-1.371 3.909.687 8.188 4.596 9.559l26.612 9.331c14.45 5.062 22.667 20.617 18.705 35.411l-16.7 62.326c-3.969 14.793-18.858 24.161-33.905 21.324l-95.823-18.081-36.099-21.643 29.715-110.9 42.09-.694 32.225 11.297c3.909 1.371 8.188-.688 9.56-4.597 1.37-3.909-.688-8.188-4.597-9.559l-33.49-11.74c-.836-.293-1.696-.429-2.605-.421l-40.871.674c-.886-2.004-2.635-3.605-4.916-4.216-3.705-.99-7.499.973-8.893 4.444l-62.345 1.028c-5.563.074-10.459 3.884-11.905 9.269l-12.634 47.186c-6.223 4.528-10.28 11.862-10.28 20.129v4.912h-8.677c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h8.677v12.636h-8.677c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h8.677v12.637h-8.677c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h8.677v13.15h-1.121c-5.795 0-10.51 4.715-10.51 10.51v69.784l-12.002 30.254c-1.527 3.85.355 8.209 4.206 9.737 3.849 1.528 8.209-.354 9.737-4.206l9.709-24.473 21.048 8.833c6.775 22.482 27.664 38.907 52.326 38.907 21.634 0 40.37-12.637 49.218-30.916h23.735c8.848 18.279 27.585 30.916 49.218 30.916 3.379 0 6.766-.312 10.064-.926 13.526-2.52 25.524-10.016 33.784-21.104 2.096-2.813 3.891-5.788 5.39-8.886h30.81l3.035 7.649c1.168 2.943 3.989 4.736 6.974 4.736.92 0 1.856-.17 2.764-.531 3.851-1.527 5.733-5.887 4.206-9.737l-.84-2.118h50.831c8.849 18.279 27.585 30.916 49.219 30.916s40.37-12.637 49.218-30.916h34.309c6.897 0 12.51-5.612 12.51-12.51v-45.09c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v42.6h-27.097c.458-2.844.706-5.758.706-8.729 0-30.132-24.514-54.646-54.645-54.646-13.374 0-25.634 4.837-35.142 12.843v-130.116h57.586l9.867 12.886h-32.21c-5.24 0-9.504 4.264-9.504 9.504v49.58c0 5.24 4.264 9.503 9.504 9.503h80.933v21.576c0 4.142 3.357 7.5 7.5 7.5zm-197.91-60.704v37.375h-32.88c4.478-5.015 7.876-11.094 9.716-17.949l6.408-23.915zm-171.479 33.275 21.726 4.1h-56.35l-24.736-22.839c-1.157-1.069-1.821-2.586-1.821-4.161v-13.239l11.816 7.084c-.529 3.704 1.775 7.303 5.479 8.295.65.174 1.304.257 1.946.257 1.611 0 3.15-.531 4.415-1.454l35.058 21.019c.761.456 1.596.773 2.467.938zm-74.031-145.852 56.147-.926-27.497 102.622-15.8-9.473v-30.606c0-12.989-10.006-23.679-22.713-24.783zm-21.917 61.617c0-3.781 2.137-7.07 5.264-8.731l.025-.012c1.374-.725 2.936-1.14 4.595-1.14 5.45 0 9.884 4.434 9.884 9.884v61.334c0 5.748 2.422 11.281 6.645 15.181l12.8 11.819h-39.213zm3.785 171.548-13.232-5.554 12.934-32.602h17.355c-10.18 9.647-16.653 23.153-17.057 38.156zm54.608 41.132c-21.861 0-39.646-17.785-39.646-39.645 0-21.828 17.733-39.591 39.55-39.643h.192c21.816.052 39.549 17.815 39.549 39.643.001 21.861-17.784 39.645-39.645 39.645zm53.94-30.916c.458-2.844.706-5.758.706-8.729 0-15.597-6.579-29.678-17.094-39.643h47.069c-10.516 9.966-17.094 24.046-17.094 39.643 0 2.971.247 5.885.706 8.729zm75.548 30.244c-2.395.446-4.856.672-7.316.672-21.86 0-39.645-17.785-39.645-39.645 0-21.828 17.733-39.591 39.549-39.643h.192c21.816.052 39.549 17.815 39.549 39.643 0 4.757-.832 9.383-2.438 13.732-.033.093-.071.182-.1.277-1.29 3.414-3.06 6.653-5.289 9.645-5.997 8.052-14.698 13.492-24.502 15.319zm46.64-30.244c.457-2.861.689-5.777.689-8.729 0-15.597-6.579-29.678-17.094-39.643h17.355l19.191 48.372zm36.279 0-22.009-55.476c-1.902-4.797-6.465-7.896-11.624-7.896h-235.37c-5.163 0-9.727 3.1-11.63 7.895l-1.798 4.532v-27.484h338.289v48.003c-2.892 6.656-4.504 13.991-4.504 21.698 0 2.971.247 5.885.706 8.729h-52.06zm106-48.375c21.86 0 39.645 17.785 39.645 39.646s-17.785 39.645-39.645 39.645c-21.861 0-39.646-17.785-39.646-39.645s17.785-39.646 39.646-39.646zm5.597-104.388h38.201l29.549 38.588h-67.75z" />
          <path d="m415.963 380.082c13.085 0 23.73-10.645 23.73-23.73s-10.645-23.731-23.73-23.731c-13.086 0-23.731 10.645-23.731 23.731 0 13.084 10.645 23.73 23.731 23.73zm0-32.462c4.814 0 8.73 3.917 8.73 8.731s-3.916 8.73-8.73 8.73-8.731-3.917-8.731-8.73c0-4.814 3.917-8.731 8.731-8.731z" />
          <path d="m97.556 332.62c-13.086 0-23.731 10.645-23.731 23.731 0 13.085 10.645 23.73 23.731 23.73 13.085 0 23.73-10.645 23.73-23.73.001-13.085-10.645-23.731-23.73-23.731zm0 32.462c-4.814 0-8.731-3.917-8.731-8.73 0-4.814 3.917-8.731 8.731-8.731s8.73 3.917 8.73 8.731c.001 4.813-3.915 8.73-8.73 8.73z" />
          <path d="m219.728 332.62c-13.085 0-23.73 10.645-23.73 23.731 0 13.085 10.645 23.73 23.73 23.73s23.73-10.645 23.73-23.73-10.645-23.731-23.73-23.731zm0 32.462c-4.814 0-8.73-3.917-8.73-8.73 0-4.814 3.916-8.731 8.73-8.731s8.73 3.917 8.73 8.731c0 4.813-3.916 8.73-8.73 8.73z" />
        </g>
      </svg>`
  }),
  Tipper: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg viewBox="0 0 461.894 461.894" height="30" width="40">
        <path d="m423.438,329.101l36.411-55.592c3.691-5.637 2.251-13.186-3.257-17.067l-185.422-130.655c2.815-11.029 2.254-22.641-1.738-33.564-5.228-14.308-15.715-25.724-29.529-32.144-6.257-2.908-13.692-0.194-16.604,6.067-2.909,6.261-0.193,13.694 6.067,16.604 7.759,3.606 13.649,10.018 16.585,18.053 2.937,8.036 2.567,16.734-1.038,24.493-0.005,0.009-0.009,0.018-0.013,0.027l-45.406,97.704c-2.909,6.26-0.192,13.694 6.067,16.604l37.233,17.305-20.146,77.443h-63.228v-160.078c0-6.904-5.597-12.5-12.5-12.5h-107.868c-5.487,0-10.333,3.579-11.947,8.824l-26.552,86.283c-0.366,1.191-0.553,2.43-0.553,3.676v86.294c0,6.904 5.597,12.5 12.5,12.5h41.535c1.558,24.304 21.816,43.604 46.507,43.604s44.949-19.3 46.507-43.604h119.137c1.558,24.304 21.816,43.604 46.507,43.604 13.459,0 25.597-5.741 34.114-14.894 8.517,9.154 20.656,14.894 34.115,14.894 25.704,0 46.615-20.912 46.615-46.615 0-8.898-2.509-17.219-6.852-24.3 1.047-0.821 1.99-1.801 2.753-2.966zm-162.161-179.701l171.038,120.519-23.868,36.441-181.015-84.133 33.845-72.827zm-212.994,37.401h35.053v61.281h-53.91l18.857-61.281zm-23.283,86.281h70.836c6.903,0 12.5-5.597 12.5-12.5v-73.781h26.084v137.596c-8.505-9.007-20.542-14.645-33.878-14.645-17.756,0-33.221,9.982-41.09,24.626h-34.452v-61.296zm75.542,104.9c-11.919,0-21.615-9.697-21.615-21.615s9.696-21.615 21.615-21.615 21.615,9.696 21.615,21.615-9.696,21.615-21.615,21.615zm171.062-43.604h-23.124l17.359-66.731 97.782,45.448c-6.435,2.582-12.165,6.555-16.814,11.552-8.517-9.153-20.655-14.894-34.114-14.894-17.756-0.001-33.221,9.981-41.089,24.625zm41.089,43.604c-11.919,0-21.615-9.697-21.615-21.615s9.696-21.615 21.615-21.615c11.918,0 21.614,9.696 21.614,21.615s-9.696,21.615-21.614,21.615zm68.23,0c-11.919,0-21.615-9.697-21.615-21.615s9.696-21.615 21.615-21.615 21.615,9.696 21.615,21.615-9.696,21.615-21.615,21.615z" />
      </svg>`
  }),
  Digger: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg width="40" height="30" viewBox="0 0 493.188 493.188">
        <path
          d="M81.248,275.235C36.448,275.235,0,311.689,0,356.483c0,44.8,36.448,81.248,81.248,81.248
		c44.796,0,81.248-36.448,81.248-81.248C162.496,311.689,126.043,275.235,81.248,275.235z M81.248,409.716
		c-29.352,0-53.232-23.881-53.232-53.232c0-29.346,23.88-53.231,53.232-53.231c29.349,0,53.231,23.886,53.231,53.231
		C134.479,385.835,110.596,409.716,81.248,409.716z M304.438,287.843c-39.002,0-70.741,31.732-70.741,70.742
		c0,39.016,31.739,70.742,70.741,70.742c39.005,0,70.742-31.727,70.742-70.742C375.181,319.575,343.448,287.843,304.438,287.843z
		 M304.438,401.312c-23.562,0-42.725-19.171-42.725-42.728c0-23.552,19.163-42.726,42.725-42.726
		c23.563,0,42.726,19.174,42.726,42.726C347.164,382.142,328.002,401.312,304.438,401.312z M490.06,142.112l-11.248-5.521
		c-0.588-0.29-1.206-0.47-1.85-0.547l-30.974-3.442l-9.116-72.247c-0.266-2.128-1.728-3.917-3.759-4.608
		c-2.036-0.677-4.285-0.146-5.789,1.375l-55.334,56.137c-1.283,1.308-1.854,3.163-1.516,4.979l1.469,7.699l-37.376,10.577
		l-51.239,111.65h-5.963v-0.93c0-1.932,0.118-3.781,0.271-5.598h-6.769L224.726,107.19c-1.266-4.968-5.737-8.438-10.858-8.438H94.32
		c-6.185,0-11.207,5.018-11.207,11.207v113.183c-3.79-0.711-7.683-1.122-11.671-1.122c-34.815,0-63.038,28.22-63.038,63.037v21.714
		c15.201-26.007,43.346-43.529,75.645-43.529c48.405,0,87.65,39.244,87.65,87.655c0,6.747-0.834,13.292-2.279,19.612h54.184
		c-0.834-4.552-1.331-9.221-1.331-14.01c0-34.878,23.259-64.272,55.097-73.646v-6.67H301.3l53.345-116.22l22.539-6.386l2.823,14.944
		c0.285,1.472,1.141,2.763,2.377,3.606c0.929,0.629,2.018,0.958,3.128,0.958c0.361,0,0.729-0.039,1.095-0.116l102.075-20.328
		c2.353-0.471,4.146-2.386,4.459-4.766C493.453,145.489,492.216,143.169,490.06,142.112z M113.152,237.883
		c-2.388-2.123-4.93-4.06-7.625-5.794V121.149h99.621l41.912,116.734H113.152z"
        />
      </svg>`
  }),
    
    Refrigerated: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg
      width="40"
      height="30"
      viewBox="0 0 120 70"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 53V31L14 18H31V53"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M10 31H25V22H14"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <rect
        x="35"
        y="15"
        width="76"
        height="38"
        rx="3"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
      />

      <rect
        x="31"
        y="19"
        width="9"
        height="19"
        rx="2"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <path
        d="M33 24H38M33 28H38M33 32H38"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path
        d="M8 53H114"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
      />

      <g
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      >
        <path d="M78 25V43" fill="none" />
        <path d="M70 29L86 39" fill="none" />
        <path d="M70 39L86 29" fill="none" />

        <path d="M78 25L75 28" fill="none" />
        <path d="M78 25L81 28" fill="none" />

        <path d="M78 43L75 40" fill="none" />
        <path d="M78 43L81 40" fill="none" />

        <path d="M70 29L74 29" fill="none" />
        <path d="M70 29L72 33" fill="none" />

        <path d="M86 39L82 39" fill="none" />
        <path d="M86 39L84 35" fill="none" />

        <path d="M70 39L74 39" fill="none" />
        <path d="M70 39L72 35" fill="none" />

        <path d="M86 29L82 29" fill="none" />
        <path d="M86 29L84 33" fill="none" />
      </g>

      <circle
        cx="22"
        cy="54"
        r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle
        cx="79"
        cy="54"
        r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle
        cx="97"
        cy="54"
        r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />
    </svg>`
  }),

  Silo: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg
      width="40"
      height="30"
      viewBox="0 0 120 70"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 53V31L14 18H31V53"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M10 31H25V22H14"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M43 18 H99 C106 18 110 23 110 29 V40 C110 47 106 51 100 51 H44 C38 51 35 47 35 42 V27 C35 22 38 19 43 18"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M43 18V13H103V18"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M59 13V18M78 13V18M96 13V18"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <path
        d="M44 51L51 58L58 51"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      />

      <path
        d="M65 51L72 58L79 51"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      />

      <path
        d="M86 51L93 58L100 51"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      />

      <path
        d="M110 25H115V52"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M110 32H115M110 39H115M110 46H115"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />

      <path
        d="M8 53H114"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
      />

      <circle
        cx="22"
        cy="54"
        r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
      />

      <circle
        cx="75"
        cy="54"
        r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
      />

      <circle
        cx="93"
        cy="54"
        r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
      />

      <circle
        cx="108"
        cy="54"
        r="7"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
      />
    </svg>`
  }),
  TipperTrailer: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg
      width="40"
      height="30"
      viewBox="0 0 120 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 53V31L11 18H28V53"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M7 31H22V22H11"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M35 20L108 24L101 45H42L35 20Z"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M43 24L47 41M59 23L62 41M76 24L78 41M93 25L95 41"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      />

      <path d="M28 50H105"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
      />

      <path d="M43 46V55M40 55H46"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />

      <circle cx="18" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="72" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="90" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="106" cy="54" r="7"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />
    </svg>`
  }),

  LowLoader: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg
      width="40"
      height="30"
      viewBox="0 0 120 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 53V31L11 18H28V53"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M7 31H22V22H11"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M29 32H47V40H55"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M55 40V48H103L111 43"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M105 43V20M113 43V18"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
      />

      <path d="M105 25L113 31M105 33L113 39"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path d="M5 53H114"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
      />

      <circle cx="18" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="82" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="99" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />
    </svg>`
  }),

  BoxTrailer: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg
      width="40"
      height="30"
      viewBox="0 0 120 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 53V31L11 18H28V53"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M7 31H22V22H11"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path d="M33 24H111V47H33V24Z"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      />

      <path d="M49 25V47M65 25V47M81 25V47M97 25V47"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
      />

      <path d="M34 35H110"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />

      <path d="M5 53H114"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
      />

      <path d="M39 48V56M36 56H42"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />

      <circle cx="18" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="76" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="94" cy="54" r="8"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />

      <circle cx="108" cy="54" r="7"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      />
    </svg>`
  }),
    RigidTruck: L.divIcon({
      className: `${style.myDivIcon}`,
      iconSize: [30, 35],
      iconAnchor: [15, 35],
      popupAnchor: [0, -35],
      html: `<svg
        width="40"
        height="30"
        viewBox="0 0 120 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 53V31L11 18H27V53"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <path
          d="M7 31H21V22H11"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <rect
          x="30"
          y="18"
          width="37"
          height="32"
          rx="2"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
        />

        <path
          d="M67 47L75 51L80 47"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <rect
          x="80"
          y="18"
          width="35"
          height="32"
          rx="2"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
        />

        <path
          d="M31 43H66M81 43H114"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />

        <path
          d="M5 53H68M79 53H117"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
        />

        <circle
          cx="17"
          cy="54"
          r="8"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
        />

        <circle
          cx="57"
          cy="54"
          r="8"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
        />

        <circle
          cx="91"
          cy="54"
          r="8"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
        />

        <circle
          cx="108"
          cy="54"
          r="8"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
        />
      </svg>`
    }
  ),
  Shop: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg width="40" height="30" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 25h46l-5-14H14L9 25z" />
        <path d="M9 25c0 7 9 9 12 2 3 7 11 7 14 0 3 7 11 7 14 0 3 7 12 5 12-2" />
        <path d="M14 33v21h36V33M22 54V39h14v15M41 39h5v7h-5z" />
      </g>
    </svg>`,
  }),
  Service: L.divIcon({
    className: `${style.myDivIcon}`,
    iconSize: [30, 35],
    iconAnchor: [15, 35],
    popupAnchor: [0, -35],
    html: `<svg width="40" height="30" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
        <path d="M48 8a17 17 0 0 0-19 21L10 48a7 7 0 0 0 10 10l19-19A17 17 0 0 0 56 16L46 26l-9-3-3-9L44 4" />
        <circle cx="16" cy="52" r="1.5" fill="currentColor" stroke="none" />
      </g>
    </svg>`,
  }),
};
